// Copyright (c) 2022 Deere & Company

import t from 'tcomb';

const ImplementSerialNumber = t.struct({
    isEditable: t.Bool,
    serialNumber: t.String

}, {
    name: 'ImplementSerialNumber',
    strict: true
});

export const getDefaultState = () => new ImplementSerialNumber({
    isEditable: true,
    serialNumber: ''

});

export default ImplementSerialNumber;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/implement-serial-number.js